import React from 'react'

const Services = () => {
  return <div>Services page</div>
}

export default Services
